export const DELIVERY_LINES = {"CD":[{
    "id":1,
    "label":"1 - 元朗線",
    "m18id":"26"
},{
    "id":2,
    "label":"2 - 九龍線",
    "m18id":"27"
},{
    "id":3,
    "label":"3 - 官將線",
    "m18id":"28"
},{
    "id":4,
    "label":"4 - 香港仔線",
    "m18id":"29"
},{
    "id":5,
    "label":"5 - 柴灣線",
    "m18id":"30"
},{
    "id":6,
    "label":"6 - 油旺線",
    "m18id":"31"
},{
    "id":7,
    "label":"7 - 馬沙線",
    "m18id":"32"
},{
    "id":8,
    "label":"8 - 荃青線",
    "m18id":"33"
},{
    "id":9,
    "label":"9 - 尖深線",
    "m18id":"34"
},{
    "id":10,
    "label":"10 - 新墟線",
    "m18id":"35"
},{
    "id":11,
    "label":"11 - 大埔線",
    "m18id":"36"
},{
    "id":12,
    "label":"12 - 荃官線",
    "m18id":"37"
},{
    "id":13,
    "label":"13 - 西九線",
    "m18id":"38"
},{
    "id":14,
    "label":"14 - 利來線",
    "m18id":"40"
},{
    "id":15,
    "label":"15 - 盛財線",
    "m18id":"39"
},{
    "id":16,
    "label":"16 - 灣仔線",
    "m18id":"41"
},{
    "id":17,
    "label":"17 - 公司線",
    "m18id":"43"
},{
    "id":18,
    "label":"18 - 分流線1",
    "m18id":"44"
},{
    "id":19,
    "label":"19 - 分流線2",
    "m18id":"45"
}],
"TS":[{
    "id":97,
    "label":"香港島"
},{
    "id":98,
    "label":"九龍"
},{
    "id":99,
    "label":"新界"
}],
"LK":[{
    "id":1,
    "label":"LKH"
},{
    "id":2,
    "label":"Yuki"
},{
    "id":3,
    "label":"Nicole"
},{
    "id":4,
    "label":"Frances"
},{
    "id":5,
    "label":"Sally"
},{
    "id":6,
    "label":"Joyce"
},{
    "id":7,
    "label":"Tammy"
}],
"SHANTOU":[{
    "id":1,
    "label":"LKH"
}],
"HS01":[{
    "id":1,
    "label":"Default"
}]};